export const authRoutes = ["/login", "/forgot-password", "/set-up-password", "/reset-password"];
